

































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { ResultadoStatus, EstatisticaLeadService } from "@/services/estatistica-lead.service";
import moment from "moment";
import { LeadService, Lead } from "@/services/lead.service";

@Component({})
export default class FunilDeVendas extends Vue {
  listaFunilTV: ResultadoStatus[] | null = null;
  loadingFunil = false;

  leadsOportunidades: Lead[] | null = null;
  leadsPrimeiroContato: Lead[] | null = null;
  leadsSegundoContato: Lead[] | null = null;
  leadsAtendimento: Lead[] | null = null;

  @Prop() readonly date!: string | null;

  mounted() {
    this.onChangeDate();
    this.fetchLeads();
  }

  @Watch("data")
  async onChangeDate() {
    this.loadingFunil = true;

    try {
      this.listaFunilTV = await EstatisticaLeadService.resultadoPorStatus(
        moment(`${this.date}-01`).toDate()
      );
    } finally {
      this.loadingFunil = false;
    }
  }

  async fetchLeads() {
    this.loadingFunil = true;
    try {
      this.leadsOportunidades = await LeadService.listarLeads(0);
      this.leadsPrimeiroContato = await LeadService.listarLeads(1);
      this.leadsSegundoContato = await LeadService.listarLeads(2);
      this.leadsAtendimento = await LeadService.listarQualificados();
    } finally {
      this.loadingFunil = false;
    }
  }
}
